import { useEffect, useState } from "react";
import { api, errMsg, newIdemKey } from "../../api";
import { Btn, Field, Notice, Select } from "../../components/ui";
import { useMe } from "../../session";

interface Prefs { inApp: boolean; email: boolean; leadDays: number; overdue: boolean; payables: boolean; receivables: boolean; cardInvoices: boolean; emailHour: number; emailAvailable?: boolean }

/** Configurações > Avisos: quando e como avisar sobre vencimentos (sino e e-mail). */
export function NotificationPrefs() {
  const { me } = useMe(); const realm = me.user.realm;
  const [p, setP] = useState<Prefs | null>(null); const [msg, setMsg] = useState<{ kind: "ok" | "error"; text: string } | null>(null); const [busy, setBusy] = useState(false);
  useEffect(() => { void api<Prefs>("GET", `/api/${realm}/notification-prefs`).then(setP).catch((e) => setMsg({ kind: "error", text: errMsg(e) })); }, [realm]);
  if (!p) return msg ? <Notice kind="error">{msg.text}</Notice> : <p className="muted">Carregando…</p>;
  const set = <K extends keyof Prefs>(k: K, v: Prefs[K]) => setP({ ...p, [k]: v });
  const save = async () => {
    setBusy(true); setMsg(null);
    try { const { emailAvailable: _a, ...body } = p; const r = await api<Prefs>("PUT", `/api/${realm}/notification-prefs`, body); setP(r); setMsg({ kind: "ok", text: "Preferências salvas." }); }
    catch (e) { setMsg({ kind: "error", text: errMsg(e) }); } finally { setBusy(false); }
  };
  const test = async () => {
    setBusy(true); setMsg(null);
    try { await api("POST", `/api/${realm}/notification-prefs/test-email`, {}, newIdemKey()); setMsg({ kind: "ok", text: "E-mail de teste enviado. Confira a sua caixa de entrada (e o spam)." }); }
    catch (e) { setMsg({ kind: "error", text: errMsg(e) }); } finally { setBusy(false); }
  };
  const Check = ({ k, label, hint }: { k: "inApp" | "email" | "overdue" | "payables" | "receivables" | "cardInvoices"; label: string; hint?: string }) => (
    <label style={{ display: "flex", gap: 10, alignItems: "flex-start", margin: "8px 0" }}>
      <input type="checkbox" checked={p[k]} onChange={(e) => set(k, e.target.checked)} data-pref={k} style={{ marginTop: 3 }} />
      <span>{label}{hint && <span className="muted small" style={{ display: "block" }}>{hint}</span>}</span>
    </label>
  );
  return (
    <div className="card" style={{ maxWidth: 640 }} data-notification-prefs>
      <h3 style={{ fontSize: 16, marginBottom: 6 }}>Avisos de vencimento</h3>
      <p className="muted" style={{ marginTop: 0 }}>Escolha o que avisar e por onde. Os avisos aparecem no sino e, se quiser, chegam num resumo diário por e-mail.</p>
      {msg && <Notice kind={msg.kind}>{msg.text}</Notice>}
      <h4>O que avisar</h4>
      <Check k="payables" label="Contas a pagar" hint="Inclui parcelas de empréstimos e financiamentos." />
      <Check k="receivables" label="Contas a receber" />
      <Check k="cardInvoices" label="Faturas de cartão de crédito" />
      <Check k="overdue" label="Itens em atraso" hint="Continua avisando sobre o que já venceu e não foi pago (até 90 dias)." />
      <Field label="Avisar com antecedência de">
        <Select value={String(p.leadDays)} onChange={(e) => set("leadDays", Number(e.target.value))} data-pref="leadDays">
          {[0, 1, 2, 3, 5, 7, 10, 15, 30].map((d) => <option key={d} value={d}>{d === 0 ? "No dia do vencimento" : d === 1 ? "1 dia" : `${d} dias`}</option>)}
        </Select>
      </Field>
      <h4>Por onde</h4>
      <Check k="inApp" label="No sino do sistema" />
      <Check k="email" label="Por e-mail (um resumo por dia)" hint={p.emailAvailable ? "Enviado para o e-mail do seu cadastro." : "O envio de e-mail ainda não está configurado neste ambiente; a preferência fica salva e vale quando for ativado."} />
      {p.email && (
        <Field label="Enviar o resumo a partir das">
          <Select value={String(p.emailHour)} onChange={(e) => set("emailHour", Number(e.target.value))} data-pref="emailHour">
            {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{String(h).padStart(2, "0")}:00</option>)}
          </Select>
        </Field>
      )}
      <div className="modal-actions" style={{ marginTop: 12 }}>
        <Btn onClick={() => void save()} disabled={busy} data-pref-save>Salvar</Btn>
        {p.emailAvailable && <Btn variant="ghost" onClick={() => void test()} disabled={busy}>Enviar e-mail de teste</Btn>}
      </div>
    </div>
  );
}
